<div class="wrapper">
    <div class="row table-toolbar">
        <div class="cal-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div class="">
                <form [formGroup]="AdvancedSearchForm" (ngSubmit)="AdvancedSearchFormSubmit()">
                    <div class="row">
                        <div class="">
                            <mat-form-field>
                                <mat-label>User</mat-label>
                                <input type="hidden" formControlName="user_id">
                                <input matInput placeholder="Search" [matAutocomplete]="auto" [formControl]="searchUserNameCtrl" [multiple]="true">
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySearchUserName" (optionSelected)="onOptionSelected($event)">
                                    <mat-option value="al">All Users</mat-option>       
                                        <mat-option *ngFor="let user of users;" [value]="user">
                                        <span>{{user?.name}}</span>
                                    </mat-option>
                                </mat-autocomplete>
                                <!-- <mat-error *ngIf="AdvancedSearchForm?.user_id?.errors?.required">This field is required.</mat-error> -->
                            </mat-form-field>
    
                        </div>
                        <!-- <div class="">
                            <mat-form-field>
                                <mat-label> From Date</mat-label>
                                <input matInput [max]="fromMaxDate" formControlName="from_date" [min]="fromMinDate" (dateInput)="onFromDateChange($event)" [matDatepicker]="leave_from_date" (focus)="leave_from_date.open()">
                                <mat-datepicker-toggle matSuffix [for]="leave_from_date"></mat-datepicker-toggle>
                                <mat-datepicker #leave_from_date></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="">
                            <mat-form-field>
                                <mat-label> To Date</mat-label>
                                <input matInput [max]="toMaxDate" formControlName="to_date" [min]="toMinDate" (dateInput)="onToDateChange($event)" [matDatepicker]="leave_to_date" (focus)="leave_to_date.open()">
                                <mat-datepicker-toggle matSuffix [for]="leave_to_date"></mat-datepicker-toggle>
                                <mat-datepicker #leave_to_date></mat-datepicker>
                            </mat-form-field>
                        </div> -->
                        
                        <div class="">
                            <div class="button-group">

                            <button type="submit" mat-raised-button class="btn-int-blue forSearch">Search </button>
                        </div>
                    </div>
                       
                    </div>
                </form>
            </div>
        </div>

        <div class="cal-xl-6 col-lg-6 col-md-12 col-sm-12">

            <mat-paginator #paginator [length]="page_length" [pageSize]="items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="handlePage($event)"></mat-paginator>
        </div>
        <div class="cal-xl-2 col-lg-2 col-md-12 col-sm-12">
            <div class="button-group" *appUserRole="[Role.OrganizationAdmin,Role.User,Role.UserReport]">
                <button type="button" (click)="createLeave()" class="btn-int-blue" mat-raised-button>Apply Leave</button>
            </div>

        </div>
    </div>

    <div class="row">
        <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="mat-table-responsive">
                <table mat-table [dataSource]="leavesDataSource">

                    <ng-container matColumnDef="org_name">
                        <th mat-header-cell *matHeaderCellDef>Organization </th>
                        <td mat-cell *matCellDef="let element"> {{element.org_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="applied_user">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.applied_user}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leave_from">
                        <th mat-header-cell *matHeaderCellDef> Leave From </th>
                        <td mat-cell *matCellDef="let element"> {{element.leave_from}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leave_to">
                        <th mat-header-cell *matHeaderCellDef>Leave To </th>
                        <td mat-cell *matCellDef="let element"> {{element.leave_to}} </td>
                    </ng-container>

                    <ng-container matColumnDef="from_session">
                        <th mat-header-cell *matHeaderCellDef> From Session </th>
                        <td mat-cell *matCellDef="let element"> {{(element.from_session ==="1")?'Morning':(element.from_session ==="2")? 'Afternoon' : ' - '}} </td>
                    </ng-container>

                    <ng-container matColumnDef="to_session">
                        <th mat-header-cell *matHeaderCellDef> To Session</th>
                        <td mat-cell *matCellDef="let element"> {{ (element.to_session ==="1")?'Morning':(element.to_session ==="2")? 'Afternoon' : ' - '}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leave_days">
                        <th mat-header-cell *matHeaderCellDef> Leave Days </th>
                        <td mat-cell *matCellDef="let element"> {{element.leave_days}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leave_reason">
                        <th mat-header-cell *matHeaderCellDef>Leave Reason </th>
                        <td mat-cell *matCellDef="let element" style="width: 200px;"> {{(element.leave_reason != null && element.leave_reason != '' )?element.leave_reason: ' - '}} </td>
                    </ng-container>

                    <ng-container matColumnDef="applied_to">
                        <th mat-header-cell *matHeaderCellDef> Applied To </th>
                        <td mat-cell *matCellDef="let element"> {{element.applied_to}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leave_status">
                        <th mat-header-cell *matHeaderCellDef> Status</th>
                        <td mat-cell *matCellDef="let element"> {{element.leave_status_desc}} </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns | tableShowColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns | tableShowColumns;"></tr>
                </table>
                <ng-container *ngIf="leavesDataSource?.filteredData?.length == 0">
                    <div class="row forNoRecords">
                        <h3 class="table-no-date"> No Record found</h3>
                    </div>
                </ng-container>
                <app-table-loader></app-table-loader>
            </div>

        </div>
    </div>
</div>